module.exports = __webpack_public_path__ + "static/img/logo90.1381874.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo90.png
// module id = YfKQ
// module chunks = 1